import * as React from 'react';
import Input, { InputProps } from './Input';
import FieldDecorator from './FieldDecorator';

// This Component can be used to wrap an input, otherwise it will generate an input automatically.
const Field = (props: Props) => {
	const { onValueChange, htmlFor, errorMessage, displayOptionalLabel, ...rest } = props;
	const [errorMessageState, setErrorMessageState] = React.useState('');

	const handleOnChange = (name: string, value: string | boolean, updatedErrorMessage: string) => {
		// This is so that the onMount validation won't display an error message.
		if (props.value !== value) {
			setErrorMessageState(updatedErrorMessage);
		}
		onValueChange(name, value, updatedErrorMessage);
	};

	return (
		<FieldDecorator
			className={props.className}
			label={props.label}
			htmlFor={htmlFor || props.name}
			errorMessage={errorMessage || errorMessageState}
			displayOptionalLabel={displayOptionalLabel}
		>
			{/* eslint-disable-next-line react/jsx-props-no-spreading */}
			<Input id={props.name} {...rest} onValueChange={handleOnChange} />
		</FieldDecorator>
	);
};

interface Props extends InputProps {
	htmlFor?: string;
	errorMessage?: string;
	validate?: (value: string | boolean) => string;
	patternErrorMessage?: string;
	displayOptionalLabel?: boolean;
}

Field.defaultProps = {
	htmlFor: null,
	errorMessage: null,
	validate: null,
	patternErrorMessage: null,
	displayOptionalLabel: false
};

export default Field;
